module.exports = __webpack_public_path__ + "static/media/uzucarto.0fcd10a8.png";